<!--
  O mesmo que temos hoje
  Conteúdo será revisado posteriormente
  Tirar última frase em negrito da página de educ. infantil
-->
<template>
  <section v-if="$store.getters.materiais(segmento).length">
    <h3>
      <a href="/institucional/lista-de-materiais">
        <v-icon>list_alt</v-icon>Lista de Materiais
      </a>
    </h3>
    <p>
    <a href="/institucional/lista-de-materiais">Baixei aqui a lista de materiais</a></p>
    <br>
  </section>
</template>

<script>
export default {
  props: { segmento: Number },
  data: () => ({}),
  methods: {
    emBreve() {
      alert("Material e os livros didáticos adotados em 2021 serão disponibilizados em breve.");
    }
  },
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}
</style>



